/**
 * Brand mark — same assets as index.html favicons.
 * `forDarkBackground`: use favicon-dark.png on saturated / dark surfaces.
 */
type AppLogoProps = {
  className?: string;
  /** Tailwind size utilities, e.g. w-8 h-8 */
  sizeClassName?: string;
  forDarkBackground?: boolean;
};

export function AppLogo({
  className = '',
  sizeClassName = 'w-8 h-8',
  forDarkBackground = false,
}: AppLogoProps) {
  const src = forDarkBackground ? '/favicon-dark.png' : '/favicon.png';
  return (
    <img
      src={src}
      alt="Athen.ai"
      className={`object-contain ${sizeClassName} ${className}`.trim()}
      loading="lazy"
      decoding="async"
    />
  );
}
